import {Component} from '@angular/core';

@Component({
  selector: 'app-check-circle-icon',
  styles: `
    :host {
      height: 24px;
      min-width: 24px;
      display: inline-block;
      color: green;
      line-height: 0;
      margin-right: 5px;
    }
  `,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
         className="size-6">
      <path strokeLinecap="round" strokeLinejoin="round"
            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
    </svg>
  `,
  standalone: true
})

export class CheckCircleIconComponent {

}
